import Footer from "../components/Footer"
import Header from "../components/Header"
import HomeMain from "../components/HomeMain"


const Home = () => {
    return(
        <div className="index-page">
            <Header />
            <HomeMain />
            <Footer />
        </div>
    )
}

export default Home